export const currentStatePaypalScreen = {
    IDLE: "IDLE",
    FETCH_DATA: "FETCH_DATA",
    SUBMIT_FORM: "SUBMIT_FORM",
    PAYMENT_SUCCEDEED: "PAYMENT_SUCCEDEED",
    TOKEN_ERROR: "TOKEN_ERROR",
   };
   